export default __webpack_public_path__ + "static/GT-America-Condensed-Black-Italic-89f80b9f0514f1ba198c6f4d3b4191c5.woff";